import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './privacy.css';

function Privacy({ onClose, embedded = false }) {
  const navigate = useNavigate();
  const [selectedVersion, setSelectedVersion] = useState('v1.0-2025-07-31');

  const handleBack = () => {
    if (onClose) {
      onClose();
    } else {
      navigate(-1);
    }
  };

  const privacyVersions = [
    { id: 'v1.0-2025-07-31', version: 'v 1.0', status: 'new', date: '2025.07.31' }
  ];

  const getVersionLabel = (version) => {
    const selected = privacyVersions.find(v => v.id === version);
    if (!selected) return '';
    
    const statusText = selected.status === 'new' ? 'new' : 
                      selected.status === 'previous' ? 'previous' : 'initial';
    
    return `${selected.version} - ${statusText} - ${selected.date}`;
  };

  return (
    <>
      {!embedded && (
        <Helmet>
          <title>개인정보처리방침 - 주식회사 가까운물류</title>
        </Helmet>
      )}
      {/* 오버레이 */}
      <div className="gakkaun-privacy-modal-overlay" onClick={handleBack}></div>
      
      {/* 팝업 */}
      <div className="gakkaun-privacy-modal">
        {/* 헤더 */}
        <header className="gakkaun-privacy-header">
          <button onClick={handleBack} className="gakkaun-back-btn">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <h1 className="gakkaun-privacy-title">개인정보처리방침</h1>
        </header>

        {/* 메인 콘텐츠 */}
        <main className="gakkaun-privacy-main">
        <div className="gakkaun-privacy-container">
          <div className="gakkaun-privacy-content">
            <div className="gakkaun-version-selector">
              <select 
                value={selectedVersion} 
                onChange={(e) => setSelectedVersion(e.target.value)}
                className="gakkaun-version-select"
              >
                {privacyVersions.map(version => (
                  <option key={version.id} value={version.id}>
                    {getVersionLabel(version.id)}
                  </option>
                ))}
              </select>
            </div>
            <div className="gakkaun-privacy-intro">
              <p>
                가까운 물류(이하 "회사")는 「개인정보 보호법」에 따라 이용자의 개인정보를 보호하고
                관련 고충을 신속하게 처리하기 위하여 다음과 같이 개인정보 처리방침을 수립하여 공개합니다.
              </p>
            </div>

            <div className="gakkaun-privacy-section">
              <h2 className="gakkaun-section-title">제1조 (개인정보의 처리목적)</h2>
              <p className="gakkaun-section-content">
                회사는 화물 유통 및 운송 연결 서비스 제공을 위해 다음 목적의 범위 내에서만 개인정보를 처리합니다.
              </p>
              <ul className="gakkaun-section-list">
                <li>운송 요청 및 운송사 매칭, 고객 상담</li>
                <li>서비스 이용 문의 및 민원 처리</li>
                <li>법령에 따른 의무 이행(세금 신고 등)</li>
              </ul>
            </div>

            <div className="gakkaun-privacy-section">
              <h2 className="gakkaun-section-title">제2조 (처리하는 개인정보 항목)</h2>
              <p className="gakkaun-section-content">
                회사는 서비스 제공을 위해 최소한의 개인정보를 수집·이용합니다.
              </p>
              <div className="gakkaun-info-grid">
                <div className="gakkaun-info-item">
                  <span className="gakkaun-info-label">필수항목</span>
                  <span className="gakkaun-info-value">이름, 연락처(전화번호), 화물 관련 정보(출발지, 도착지 등)</span>
                </div>
                <div className="gakkaun-info-item">
                  <span className="gakkaun-info-label">선택항목</span>
                  <span className="gakkaun-info-value">이메일, 기타 서비스 요청 시 필요한 정보</span>
                </div>
              </div>
            </div>

            <div className="gakkaun-privacy-section">
              <h2 className="gakkaun-section-title">제3조 (개인정보의 처리 및 보유기간)</h2>
              <div className="gakkaun-section-content">
                <p>① 회사는 개인정보 수집 시 동의받은 보유기간 내에서만 개인정보를 처리·보유합니다.</p>
                <p>② 관련 법령(상법, 국세기본법 등)에 따라 거래 기록을 최대 5년까지 보관할 수 있습니다.</p>
              </div>
            </div>

            <div className="gakkaun-privacy-section">
              <h2 className="gakkaun-section-title">제4조 (개인정보의 제3자 제공)</h2>
              <p className="gakkaun-section-content">
                회사는 원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다.
                다만, 운송 계약 체결 및 이행을 위해 필요한 경우(운송사에 수화인 정보를 전달 등)에는 사전에 동의를 받습니다.
              </p>
            </div>

            <div className="gakkaun-privacy-section">
              <h2 className="gakkaun-section-title">제5조 (개인정보 처리의 위탁)</h2>
              <p className="gakkaun-section-content">
                현재 회사는 개인정보 처리를 외부 업체에 위탁하지 않습니다.
              </p>
            </div>

            <div className="gakkaun-privacy-section">
              <h2 className="gakkaun-section-title">제6조 (개인정보의 파기)</h2>
              <p className="gakkaun-section-content">
                회사는 개인정보 보유기간이 경과하거나 처리목적이 달성된 경우에는 지체 없이 파기합니다.
              </p>
              <ul className="gakkaun-section-list">
                <li>전자파일 : 복구 불가능한 기술적 방법으로 삭제</li>
                <li>문서 : 파쇄 또는 소각</li>
              </ul>
            </div>

            <div className="gakkaun-privacy-section">
              <h2 className="gakkaun-section-title">제7조 (이용자 권리와 행사방법)</h2>
              <p className="gakkaun-section-content">
                이용자는 언제든지 자신의 개인정보에 대해 열람, 정정, 삭제, 처리정지 요청을 할 수 있습니다.
                회사는 요청을 받은 즉시 조치하며, 법령에 따라 보관해야 하는 경우에는 예외로 할 수 있습니다.
              </p>
            </div>

            <div className="gakkaun-privacy-section">
              <h2 className="gakkaun-section-title">제8조 (개인정보의 안전성 확보조치)</h2>
              <p className="gakkaun-section-content">
                회사는 개인정보 보호를 위해 접근권한 관리, 보안프로그램 설치, 정기 점검 등 안전성 확보에 필요한 조치를 합니다.
              </p>
            </div>

            <div className="gakkaun-privacy-section">
              <h2 className="gakkaun-section-title">제9조 (개인정보 보호책임자)</h2>
              <div className="gakkaun-contact-card">
                <div className="gakkaun-contact-row">
                  <span className="gakkaun-contact-label">개인정보 보호책임자</span>
                  <span className="gakkaun-contact-value">김종은</span>
                </div>
                <div className="gakkaun-contact-row">
                  <span className="gakkaun-contact-label">연락처</span>
                  <span className="gakkaun-contact-value">070-5089-3313 / h0118899795@naver.com</span>
                </div>
              </div>
            </div>

            <div className="gakkaun-privacy-section">
              <h2 className="gakkaun-section-title">제10조 (권익침해 구제방법)</h2>
              <p className="gakkaun-section-content">
                개인정보 침해에 대한 상담 및 피해구제는 아래 기관에 문의할 수 있습니다.
              </p>
              <div className="gakkaun-help-list">
                <div className="gakkaun-help-item">
                  <span className="gakkaun-help-name">개인정보침해신고센터</span>
                  <span className="gakkaun-help-contact">privacy.kisa.or.kr / 118</span>
                </div>
                <div className="gakkaun-help-item">
                  <span className="gakkaun-help-name">개인정보 분쟁조정위원회</span>
                  <span className="gakkaun-help-contact">www.kopico.go.kr / 1833-6972</span>
                </div>
                <div className="gakkaun-help-item">
                  <span className="gakkaun-help-name">대검찰청 사이버수사과</span>
                  <span className="gakkaun-help-contact">www.spo.go.kr / 1301</span>
                </div>
                <div className="gakkaun-help-item">
                  <span className="gakkaun-help-name">경찰청 사이버안전국</span>
                  <span className="gakkaun-help-contact">ecrm.cyber.go.kr / 182</span>
                </div>
              </div>
            </div>

            <div className="gakkaun-privacy-section">
              <h2 className="gakkaun-section-title">제11조 (개인정보처리방침 변경)</h2>
              <p className="gakkaun-section-content">
                본 방침은 2025년 7월 31일부터 시행됩니다.
              </p>
            </div>
          </div>
        </div>
      </main>
      </div>
    </>
  );
}

export default Privacy;
